const PHONE = "919679200493";

export const getWhatsAppUrl = (message: string) =>
  `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;

export const getProductWhatsAppUrl = (name: string, price: number) =>
  getWhatsAppUrl(`Hi! I'm interested in buying *${name}* (₹${price.toLocaleString('en-IN')}). Please share details.`);

export const getCartWhatsAppUrl = (items: { name: string; price: number; qty: number }[]) => {
  const itemsList = items.map(i => `• ${i.name} x${i.qty} — ₹${(i.price * i.qty).toLocaleString('en-IN')}`).join('\n');
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  return getWhatsAppUrl(`Hi! I'd like to order:\n\n${itemsList}\n\n*Total: ₹${total.toLocaleString('en-IN')}*`);
};
